import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

export const TABLE_CONFIG_COLUMNS_PAYMENT_METHOD: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Actions',
    width: 100,
    type: 'action',
    actions: [
      {
        name: 'edit',
        iconName: 'pencil',
      },
    ],
    alignClass: 'text-start',
  },
  {
    dataKey: 'strPaymentMethod',
    label: 'Payment Method',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'pmsPaymentType',
    label: 'PMS Payment Type',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'strStatus',
    label: 'Status',
    width: 150,
    type: 'status',
  },
];
